export default __webpack_public_path__ + "static/media/931.ddac0eb3.png";